import { Flex, theme } from 'pcln-design-system'
import styled from 'styled-components'

export const StyledFlex = styled(Flex)`
  gap: 48px;
  ${theme.mediaQueries.md} {
    gap: 32px;
  }
`
